import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../../shared/services/global.service';
import {CourseService} from '../../../../shared/services/course.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-add-university-course',
    templateUrl: './add-university-course.component.html',
    styleUrls: ['./add-university-course.component.scss']
})
export class AddUniversityCourseComponent implements OnChanges {
    addCourseForm: FormGroup;
    id: any;
    universityId: any;
    inputTypePassword: any = 'password';
    submitted: any = false;
    submitting: any = false;
    @Output() valueSubmitted = new EventEmitter<any>();
    @Input() data: any;

    constructor(private _coreSidebarService: CoreSidebarService,
                private fb: FormBuilder,
                private alertService: AlertService,
                public http: HttpClient,
                public globalService: GlobalService,
                private courseService: CourseService,
                private activatedRoute: ActivatedRoute) {
    }

    ngOnChanges(): void {
        this.universityId = this.activatedRoute.snapshot.params['id'];
        this.refresh();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-university-course').toggleOpen();
    }

    refresh() {
        this.addCourseForm = this.fb.group({
            'name': ['', Validators.required],
            'short_name': ['', Validators.required]
        });
        if (this.data && this.data['id']) {
            this.patchForm();
        }
    }

    patchForm() {
        this.addCourseForm.patchValue({
            'name': (this.data && this.data['name']) ? this.data['name'] : '',
            'short_name': (this.data && this.data['short_name']) ? this.data['short_name'] : '',
        });
    }

    submit() {
        this.submitted = true;
        if (!this.addCourseForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addCourseForm.value && this.addCourseForm.value.name) ? this.addCourseForm.value.name : '',
                'short_name': (this.addCourseForm.value && this.addCourseForm.value.short_name) ? this.addCourseForm.value.short_name : '',
            };
            this.submitting = true;
            this.courseService.createByAdmin(this.universityId, params).subscribe(data => {
                if (data) {
                    this.submitting = false;
                    this.submitted = false;
                    this.valueSubmitted.emit(true);
                    this.addCourseForm.reset();
                    this.addCourseForm.patchValue({
                        'name': '',
                        'short_name': '',
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].short_name && error['error']['errors'].short_name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].short_name[0]);
                        return;
                    }
                }
            });
        }
    }

    update() {
        this.submitted = true;
        if (!this.addCourseForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addCourseForm.value && this.addCourseForm.value.name) ? this.addCourseForm.value.name : '',
                'short_name': (this.addCourseForm.value && this.addCourseForm.value.short_name) ? this.addCourseForm.value.short_name : '',
            };
            this.submitting = true;
            this.courseService.updateByAdmin(this.universityId, this.data['id'], params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.valueSubmitted.emit(true);
            }, error => {
                this.submitting = false;
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].name[0]);
                        return;
                    }
                    if (error['error']['errors'].short_name && error['error']['errors'].short_name.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].short_name[0]);
                        return;
                    }
                }
            });
        }
    }
}
